import { useEffect, useState } from 'react';
import styles from './sportstaetten.module.css';
import Sportstaette from './Sportstaette';
import axios from 'axios';

function Sportstaetten() {
    const [sportstaetten, setSportstaetten] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalImage, setModalImage] = useState(null);
    const fetchSportstaetten = async () => {
        setLoading(true);
        try {
            const res = await axios.get('/api/sportstaetten');

            // Sort by combined display name (bezeichnung – name)
            const sorted = res.data.sort((a, b) => {
                const aDisplay = a.bezeichnung
                    ? `${a.bezeichnung} – ${a.name || ''}`
                    : a.name || '';
                const bDisplay = b.bezeichnung
                    ? `${b.bezeichnung} – ${b.name || ''}`
                    : b.name || '';
                return aDisplay.localeCompare(bDisplay, 'de', { sensitivity: 'base' });
            });

            setSportstaetten(sorted);
        } catch (err) {
            console.error('Fehler beim Laden der Sportstätten:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSportstaetten();
    }, []);

    if (loading) {
        return <div>Loading Sportstätten...</div>;
    }

    return (
        <div className={styles.content}>
            {modalImage && (
                <div className={styles.modalOverlay} onClick={() => setModalImage(null)}>
                    <div className={styles.modalForm} onClick={(e) => e.stopPropagation()}>
                        <img
                            src={modalImage}
                            alt="Vorschau"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '75vh',
                                objectFit: 'contain',
                                borderRadius: '12px'
                            }}
                        />
                    </div>
                </div>
            )}
            <h1>Unsere Sportstätten</h1>
            {sportstaetten.map((item) => (
                <Sportstaette key={item.id} anlage={item} setModalImage={setModalImage} />
            ))}
        </div>
    );
}

export default Sportstaetten;
